/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2019 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 8/20/2019.
 *
 */

import {FormattedHTMLMessage, FormattedMessage, injectIntl} from "react-intl";
import {formatDateTime} from "../common/LocaleHelper";
import {sliceItemsFromBeginning} from "../utils/Helpers";
import ExpandableList from "../common/ExpandableList";
import React from "react";
import {LOG_ACTION_TYPES} from "../faults/common/FaultsConst";

class NotificationsLogTable extends React.Component {
    getLogRow(log) {
        let changeText = '';
        switch (log.objectType) {
            case 'TEST':
            case 'CORRECTIVE_ACTION':
            case 'SYMPTOM':
                changeText = <FormattedHTMLMessage id={'notification.log.' + log.objectType + '.' + log.actionType} values={{name: log.objectName, value: log.valueName, criticality: log.criticality*100, assetName: log.affectedAssetName}} />
                break;
            case 'FAULT_CONDITION':
                if (log.actionType === LOG_ACTION_TYPES.LL_PACKET_SENT || log.actionType === LOG_ACTION_TYPES.ASSIGNEE_SET) {
                    if(log.actionType === LOG_ACTION_TYPES.ASSIGNEE_SET && log.valueId === null) {
                        changeText = <FormattedHTMLMessage
                            id={'notification.log.' + log.objectType + '.' + log.actionType + ('.UNASSIGNED')} values={{assetName: log.affectedAssetName}}/>
                    } else {
                        changeText = <FormattedHTMLMessage
                            id={'notification.log.' + log.objectType + '.' + log.actionType}
                            values={{name: log.objectName, value: log.valueName, assetName: log.affectedAssetName}}/>
                    }
                } else {
                    changeText = <FormattedHTMLMessage
                        id={'notification.log.' + log.objectType + '.' + log.actionType + (log.valueId ? '.' + log.valueId : '')}
                        values={{name: log.objectName, value: log.valueName, assetName: log.affectedAssetName}}/>
                }
                break;
            case 'ASSET':
                changeText = <FormattedHTMLMessage
                    id={'asset.log.' + log.objectType + '.' + log.actionType}
                    values={{name: log.objectName, value:log.valueId, assetName: log.affectedAssetName}}/>
                break;
            case 'FLEET':
                if (log.affectedAssetName != null) {
                    changeText = <FormattedHTMLMessage
                        id={'notification.log.' + log.objectType + '.' + log.actionType}
                        values={{name: log.objectName, value:log.valueId, assetName: log.affectedAssetName}}/>
                }
                else {
                    changeText = <FormattedHTMLMessage
                        id={'notification.log.' + log.objectType + '.' + log.actionType}
                        values={{fleetName: log.objectName, userName: log.userName}}/>
                }
                break;
            case 'USER':
                changeText = <FormattedHTMLMessage
                    id={'notification.log.' + log.objectType + '.' + log.actionType}
                    values={{userName: log.objectName}}/>
                break;
            default:
                changeText = <FormattedHTMLMessage
                    id={'notification.log.' + log.objectType + '.' + log.actionType}
                    values={{name: log.objectName, value:log.valueId, assetName: log.affectedAssetName}}/>
                break;
        }

        return (
            <div className="history-item" key={log.id}>
                <div className="history-item-header">
                    <FormattedMessage id="useranddate" values={{user: log.userName, date: formatDateTime(log.createDate)}} />
                </div>
                <div className="history-item-content">
                    {changeText}
                </div>
            </div>
        )
    }

    render() {
        const {notifications, intl} = this.props

        const logComponents = notifications.map(l => this.getLogRow(l))
        let emptyMessage = '';
        if (logComponents.length === 0) {
            emptyMessage = intl.formatMessage({id: "action.log.noAction"})
        }
        const slicedLogItems = sliceItemsFromBeginning(logComponents, this.props.initDisplayCount);

        return (
            <div className="ui history-table">
                <ExpandableList content={slicedLogItems[0]} expandedContent={slicedLogItems[1]} expandable={slicedLogItems[1].length > 0}
                                expandLinkText={intl.formatMessage({id: "action.log.more"}, {count: slicedLogItems[1].length})} direction={'down'} />
                {emptyMessage}
            </div>
        )
    }
}

NotificationsLogTable.defaultProps = {
    initDisplayCount: 5,
}

export default injectIntl(NotificationsLogTable)